import { getFlowType, viewport, iOSAPP, androidAPP } from './index';
// import { store } from '../../../configureStore';

const getChannelDetails = () => {
  let channelName = 'VZW-DOTCOM';
  const isRPFlow = sessionStorage.getItem('isRPSFlow');
  if (viewport() === 'mobile' || viewport() === 'mfapp') {
    if (isRPFlow === true || isRPFlow === 'true') {
      channelName = 'VZW-RPS';
    } else if (iOSAPP()) {
      channelName = 'VZW-MFA-IOS';
    } else if (androidAPP()) {
      channelName = 'VZW-MFA-ANDROID';
    } else {
      channelName = 'VZW-DOTCOM-MOB';
    }
  }
  return channelName;
};
export const performanceMeasure = (measureName, delayTimer) => {
  console.debug('measureName', measureName);
  console.log('measureName', measureName);
  const match = `${window?.location?.href?.split('.html', 1)}`;
  const pageName = match?.substring?.(match?.lastIndexOf?.('/') + 1);
  window.performance.mark('App_FrameProduced');
  if (delayTimer < 0) {
    setTimeout(() => {
      if (window?.performance?.measure) {
        window.performance.measure(`${pageName}:ui:${getChannelDetails()}:${getFlowType()}:render`, 'App_Start', 'App_FrameProduced');
        // window.performance.measure(`${pageName}:ui:${getChannelDetails()}:${getFlowType()}:render`);
        window.performancemeasured = true;
      }
      // if (window?.newrelic?.finished) {
      //   window.newrelic.finished?.();
      // }
    }, delayTimer);
    return null;
  }
  if (window?.performance?.measure) {
    window.performance.measure(`${pageName}:ui:${getChannelDetails()}:${getFlowType()}:render`, 'App_Start', 'App_FrameProduced');
    // window.performance.measure(`${pageName}:ui:${getChannelDetails()}:${getFlowType()}:render`);
    window.performancemeasured = true;
  }
  // if (window?.newrelic?.finished) {
  //   window.newrelic.finished?.();
  // }
};

export const runAfterFramePaint = (callback) => {
  requestAnimationFrame(() => {
    const messageChannel = new MessageChannel();
    messageChannel.port1.onmessage = callback;
    messageChannel.port2.postMessage(undefined);
  });
};

export const callPerformanceMeasure = () => {
  if (window.performance && window.performance.mark) {
    window.performance.mark('App_Start');
  }
  runAfterFramePaint(() => {
    performanceMeasure('pageName', 60);
  });
  // store.dispatch({ type: 'API_LOADED', response: false });
};
